import { Dispatch } from "redux";
import { API } from "../api/product-api";
import { APIDA } from "../api/deliveryAddress-api";  
import SHOPING_CART_CONSTANTS from "../constants/shoppingCart-constants";

export const addToCart = (id: string, qty: number = 1) => {
    return (dispatch: Dispatch, getState: any) => {
        API.getProductById(id).then((response: any) => {
            let data = response.data;
            dispatch({
                type: SHOPING_CART_CONSTANTS.CART_ADD_ITEM,
                payload: {
                    id: data._id,
                    productCode: data.productCode,
                    full_name: data.full_name,
                    categoryRef: data.categoryRef,
                    description: data.description,
                    cost: data.cost,
                    image: data.image,
                    qty,
                    amount: data.amount,
                    status: data.status
                }
            });
        })
        localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems));
    }
}

export const addDeliveryAddress = (id: string) => {
    return (dispatch: Dispatch, getState: any) => {
        APIDA.getAddress(id).then((response: any) => {
            let data = response.data;
            dispatch({
                type: SHOPING_CART_CONSTANTS.CART_ADD_ITEM,
                payload: {
                    id: data._id,
                    productCode: data.productCode,
                    full_name: data.full_name,
                    categoryRef: data.categoryRef,
                    description: data.description,
                    cost: data.cost,
                    image: data.image
                }
            });
        })
        localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems));
    }
}

export const updateQty = (id: string, qty: number) => {
    return (dispatch: Dispatch, getState: any) => {
        API.getProductById(id).then((response: any) => {
            let data = response.data;
            dispatch({
                type: SHOPING_CART_CONSTANTS.CART_UPDATE_QTY,
                payload: {
                    id: data._id,
                    productCode: data.productCode,
                    full_name: data.full_name,
                    categoryRef: data.categoryRef,
                    description: data.description,
                    cost: data.cost,
                    image: data.image,
                    qty,
                    amount: data.amount,
                    status: data.status
                }
            });
        });
        localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems));
    }
}

export const removeFromCart = (id: string) => {
    return (dispatch: Dispatch, getState: any) => {
        dispatch({
            type: SHOPING_CART_CONSTANTS.CART_REMOVE_ITEM,
            payload: id
        });
        localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems));
    }
}

export const resetMessage = () => {
    return (dispatch: Dispatch) => {
        dispatch({
            type: SHOPING_CART_CONSTANTS.CART_RESET_MESSAGE
        });
    }   
}

 